module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-10.95d67eb2.jpg";